import React from "react";
import { Controller, useForm } from "react-hook-form";
import { Box, Button, Divider, Grid, TextField } from "@mui/material";
import LoadingWrapper from "components/Shared/LoadingWrapper";
import InnerShadowBox from "components/Shared/InnerShadowBox";
import { CustomCountryPhoneInput } from "components/Shared/CustomCountryPhoneInput";

const INITIAL_STATE = {
  name: "",
  phoneNumber: "",
  isActive: true,
};

const getDefaultValues = (numberDetail, branchDetail) => {
  if (numberDetail) {
    return {
      name: numberDetail.name || "",
      phoneNumber: numberDetail.phoneNumber || "",
      isActive:
        numberDetail.isActive !== undefined ? numberDetail.isActive : true,
    };
  }
  if (branchDetail) {
    return {
      ...INITIAL_STATE,
    };
  }
  return INITIAL_STATE;
};

const AdditionalNumberForm = ({
  numberDetail = null,
  branchDetail,
  isBusy = false,
  onSubmit = () => {},
  onCancel = () => {},
}) => {
  // react form hook
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: getDefaultValues(numberDetail, branchDetail),
  });

  const handleSubmitNumber = (data) => {
    const _payload = {
      additionalNumbers: {
        phoneNumber: data?.phoneNumber,
        name: data?.name,
        isActive: data?.isActive,
      },
      numberId: numberDetail?._id,
    };

    onSubmit(_payload);
  };
  React.useEffect(() => {
    reset(getDefaultValues(numberDetail, branchDetail));
  }, [branchDetail, numberDetail, reset]);

  const renderTextField = (name, label, type = "text", rules = {}) => (
    <Grid item md={12}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <TextField
            fullWidth
            label={label}
            type={type}
            size="small"
            {...field}
          />
        )}
      />
    </Grid>
  );
  return (
    <LoadingWrapper loading={isBusy}>
      <InnerShadowBox padding={3}>
        <Grid container spacing={5}>
          {renderTextField("name", "Name", "text", {
            required: "Name is required",
          })}
          <Grid item md={12}>
            <Controller
              name="phoneNumber"
              control={control}
              rules={{ required: "Phone is required" }}
              render={({ field }) => (
                <CustomCountryPhoneInput
                  placeholder="Phone Number"
                  {...field}
                />
              )}
            />
            {errors.phone && <p className="error">{errors.phone.message}</p>}
          </Grid>
        </Grid>
      </InnerShadowBox>

      <Divider />

      <Box
        paddingX={3}
        paddingY={2}
        gap={2}
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button disabled={isBusy} onClick={onCancel}>
          Cancel
        </Button>

        <Button
          variant="outlined"
          disabled={isBusy}
          onClick={handleSubmit(handleSubmitNumber)}
        >
          {numberDetail?._id ? "Update" : "Add"}
        </Button>
      </Box>
    </LoadingWrapper>
  );
};

export default AdditionalNumberForm;
